import React, { Component, Fragment } from 'react';
import Dialog from '@material-ui/core/Dialog';
import VMButton from '@/Common/VMButton';
import './VideoCrop.scss'
import i18n from '@/i18n';
import { DataUriToFile } from "@/utils/BinaryHelper"
import { fabric } from 'fabric';
import Slider from './VideoSlider'

import { MD5 } from 'crypto-js'

import '../CropDialog.scss';

const STROKE_WIDTH = 6;

class VideoCrop extends Component {
    state = {
        crop: {},
        isFixAspect: true,
        isCheckedUseAudio: false,
        

        isReadyVideo: false,
        isPause: false,

        curVideoTime: 0, // (s)
        duration: null, // 영상 길이
    };
    
    videoRef;
    src;
    intervalId;
    orgScale;

    canvas;
    videoImg;

    value = { min:0, max:0 }
    sliderRef;
    componentWillUnmount = () => {
        this.DisposeCanvas();
    }
    DisposeCanvas = () => {
        if (this.canvas) {
            this.canvas.clear();
            this.canvas = null;
        }
    }

    setInnerRect = (obj) => {
        var heightLimit = this.videoImg.getBoundingRect().height;
        var widthLimit = this.videoImg.getBoundingRect().width;
        var beginX = this.videoImg.getBoundingRect().left;
        var beginY = this.videoImg.getBoundingRect().top;

        // if object is too big ignore
        if (obj.currentHeight > heightLimit || obj.currentWidth > widthLimit) {
            return;
        }
        obj.setCoords();
        // top-left  corner

        if (obj.getBoundingRect().top < beginY || obj.getBoundingRect().left < beginX) {
            obj.top = Math.max(obj.top, beginY + obj.top - obj.getBoundingRect().top);
            obj.left = Math.max(obj.left, beginX + obj.left - obj.getBoundingRect().left);
        }
        // bot-right corner
        if (obj.getBoundingRect().top + obj.getBoundingRect().height > beginY + heightLimit || obj.getBoundingRect().left + obj.getBoundingRect().width > beginX + widthLimit) {
            obj.top = Math.min(obj.top, heightLimit - obj.getBoundingRect().height + beginY + obj.top - obj.getBoundingRect().top);
            obj.left = Math.min(obj.left, widthLimit - obj.getBoundingRect().width + beginX + obj.left - obj.getBoundingRect().left);
        }

    }

    calcMaskRectPostion = ({ x, y, zoom, width, height }) => {
        const scale = this.orgScale.x / zoom;
        const center = {
            x: this.canvas.width * 0.5,
            y: this.canvas.height * 0.5
        }
        const left = center.x - x * (width * scale);
        const top = center.y - y * (height * scale);

        return {
            left,
            top,
            scale
        }
    }


    componentDidUpdate = () => {
        //this.DisposeCanvas();

        if (!this.canvas && this.state.vWidth) {
            const { cropMetaData } = this.props
            this.canvas = new fabric.Canvas('c', { backgroundColor: 'rgb(75,75,75)', selection: false });
            var video = document.getElementById('v');
            this.videoImg = new fabric.Image(video, {
                width: this.state.vWidth,
                height: this.state.vHeight,
                objectCaching: false,
                originX: 'center',
                originY: 'center',
                selectable: false,
                hoverCursor: 'default'
            });
            var sizeX = this.canvas.width / this.videoImg.width;
            var sizeY = this.canvas.height / this.videoImg.height;

            if (sizeX < sizeY) {
                sizeY = sizeX;
            }
            else {
                sizeX = sizeY;
            }

            this.videoImg.scaleX = sizeX;
            this.videoImg.scaleY = sizeY;



            this.canvas.centerObject(this.videoImg);

            this.canvas.add(this.videoImg);

            var fw, fh;

            if (this.props.aspect >= this.videoImg.width / this.videoImg.height) {
                fw = this.videoImg.width;
                fh = fw * 1 / this.props.aspect;
            }
            else {
                fh = this.videoImg.height;
                fw = fh * this.props.aspect;
            }

            var panel = new fabric.Rect({
                left: 0,
                top: 0,
                width: this.canvas.width,
                height: this.canvas.height,
                backgroundColor: 'rgb(0,0,0)',
                opacity: 0.8,
                selectable: false,
                hoverCursor: 'default',
            });
            var center = panel.getCenterPoint();
            this.orgScale = {
                x: this.videoImg.scaleX,
                y: this.videoImg.scaleY
            }
            let isCropped = false;
            let cropedMetaData = null;
            if (cropMetaData) {
                if (cropMetaData.crop) {
                    isCropped = true;
                    cropedMetaData = this.calcMaskRectPostion({ ...cropMetaData.crop, width: fw, height: fh });
                }
                if (cropMetaData.from && cropMetaData.to) {
                    const { from, to } = cropMetaData
                    this.handleFrameChange({ from: from * 1000, to: to * 1000 })
                }
                if (cropMetaData.enableAudio) this.setState({ isCheckedUseAudio: true })
            }

            const left = cropedMetaData ? cropedMetaData.left : center.x;
            const top = cropedMetaData ? cropedMetaData.top : center.y;
            const scaleX = cropedMetaData ? cropedMetaData.scale : this.orgScale.x;
            const scaleY = cropedMetaData ? cropedMetaData.scale : this.orgScale.y;

            var mask = new fabric.Rect({
                left,
                top,
                width: fw,
                height: fh,
                originX: 'center',
                originY: 'center',
                scaleX,
                scaleY,
                absolutePositioned: true
            });
            mask.inverted = true;

            panel.clipPath = mask;

            this.maskRect = new fabric.Rect({
                left,
                top,
                width: fw,
                height: fh,
                originX: 'center',
                originY: 'center',
                scaleX,
                scaleY,
                fill: 'rgba(0,0,0,0)',
                strokeWidth: STROKE_WIDTH,
                // lockScalingX:true,
                lockRotation: true,
                // lockScalingY:true,
                lockUniScaling: true,
                stroke: '#1fbdcb',
                lockScalingFlip: true,
                hasRotatingPoint: false,
                cornerSize: 20,
                cornerStyle: 'circle',
                cornerColor: '#1fbdcb',
                cornerStrokeColor: '#1fbdcb',
                transparentCorners: false
            });

            this.maskRect.on('moving', (e) => {
                var obj = e.target;
                this.setInnerRect(obj);

                mask.left = e.target.left;
                mask.top = e.target.top;
                mask.setCoords();
                panel.clipPath = mask;
                panel.dirty = true;
            });

            this.maskRect.on('scaling', (e) => {
                var obj = e.target;
                if (obj.scaleX > this.orgScale.x || obj.scaleY > this.orgScale.y) {
                    obj.scaleX = this.orgScale.x;
                    obj.scaleY = this.orgScale.y;
                    obj.setCoords();
                }
                this.setInnerRect(obj);

                mask.left = e.target.left;
                mask.top = e.target.top;
                mask.scaleX = obj.scaleX;
                mask.scaleY = obj.scaleY;
                mask.setCoords();
                panel.clipPath = mask;
                panel.dirty = true;

            });
            if (!isCropped) {
                this.canvas.centerObject(mask);
                this.canvas.centerObject(this.maskRect)
            }
            this.canvas.add(panel);
            this.canvas.add(this.maskRect);
            this.canvas.setActiveObject(this.maskRect)

            fabric.util.requestAnimFrame(this.videoRender);
        }

    }

    componentDidMount = () => {
        if (this.props.src) {
            this.setState({ src: this.props.src });
        }
        if (sessionStorage.getItem("provider") === "vchange") this.setState({ isCheckedUseAudio: true })
    }

    videoRender = () => {
        if (this.canvas) {
            this.canvas.renderAll();
            fabric.util.requestAnimFrame(this.videoRender);
        }
    }

    generateFilename = src => {
        let val = ''
        if (src.length <= 10000) val = src
        else {
            for (let i = 0; i < src.length; i += Math.floor(src.length / 100)) {
                val += src.slice(i, i + 100)
            }
        }
        // MD5 => 같은 파일은 같은 해시 결과를 뱉어냄.
        // 단, 5분이 지날때마다 같은 파일 입력시에는 별도 파일로 인식하도록 로직 작성 (업로드 오류현상에 대한 추가 로직)
        return `${MD5(val)}_${Math.floor(Date.now() / (1000 * 60 * 5))}`
    }


    onCropComplete = async (cropThumbnail) => {
        var center = {
            x: this.canvas.width * 0.5,
            y: this.canvas.height * 0.5
        }

        const { cropBlobData, src, cropComplete, closeDialog, cropUploadType, cropFile } = this.props
        let file = null;
        var crop = {
            x: (center.x - this.maskRect.left) / (this.maskRect.width * this.maskRect.scaleX),
            y: (center.y - this.maskRect.top) / (this.maskRect.height * this.maskRect.scaleY),
            zoom: this.orgScale.x / this.maskRect.scaleX
        }

        const filename = this.generateFilename(src)
        if (cropUploadType === "local" && (src || cropFile)) {
            file = cropFile ? cropFile : DataUriToFile(src, filename)
        } else if (cropBlobData) {
            file = this.blobToFile(cropBlobData, filename)
        }
        const thumbnailImage = DataUriToFile(cropThumbnail, filename)
        if (!thumbnailImage) {
            alert(i18n.t("makevideo.error.unsupported.video"))
            return closeDialog();
        }

        const enableAudio = this.state.isCheckedUseAudio
        cropComplete(file, { from: this.value.min / 1000, to: this.value.max / 1000, crop, enableAudio }, thumbnailImage);
        closeDialog();
    }
    endImageCrop = () => {
        if (!this.maskRect) {
            return;
        }
        const selectionRect = this.maskRect;
        let rect = new fabric.Rect({
            left: selectionRect.left,
            top: selectionRect.top,
            width: selectionRect.getScaledWidth() - STROKE_WIDTH,
            height: selectionRect.getScaledHeight() - STROKE_WIDTH,
            angle: selectionRect.angle,
            originX: 'center',
            originY: 'center',
            absolutePositioned: true,
            backgroundColor:"transparent"
        });
        this.videoImg.clipPath = rect;
        this.videoRef.pause()
        this.videoRef.currentTime = this.value.min / 1000;
        const cropped = new Image();

        const self = this;

        this.canvas.remove(selectionRect);

        const point = rect.getPointByOrigin("left", "top")
        cropped.src = this.canvas.toDataURL({
            left: point.x,
            top: point.y,
            width: rect.width,
            height: rect.height,
        });

        cropped.onload = function () {
            self.canvas.clear();
            const image = new fabric.Image(cropped);
            image.left = rect.left;
            image.top = rect.top;
            image.setCoords();
            self.canvas.add(image);
            self.onCropComplete(cropped.src);
        };
    }

    blobToFile = (blob, filename) => {
        const { mimetype } = this.props
        const extname = mimetype.split('/')[1].replace(`quicktime`, `mov`)
        return new File([blob], `${filename}.${extname}`, { type: mimetype })
    }

    checkFrameInRange = () => {
        const desDuration = this.value.max / 1000
        try {
            const curVideoTime = this.videoRef.currentTime

            // 크롭영역 재생시간이 초과한 경우 
            if(this.videoRef.currentTime >= desDuration)
            {
                // 다시 재생 (처음부터 루프)
                this.playAll()
            }

            this.setState({ curVideoTime })
        } catch (e) {
            clearInterval(this.intervalId);
        }
    }

    changeTime = (time) => {
        this.value = time;

        if (this.videoRef) {
            this.setState({ isPause: false })
            this.videoRef.currentTime = time.min / 1000
            this.videoRef.play()
        }
    }

    playAll = (isPause = false, restart = true) => {
        const { isReadyVideo } = this.state
        if(isReadyVideo) {
            if(restart) {
                this.videoRef.currentTime = this.value.min / 1000
            }

            if(isPause) {
                this.videoRef.pause()
            }
            else {
                this.videoRef.play()
            }
        }
    }

    handleKeyPress = (e) => {
        if(e.key === "ArrowLeft") {
            this.handleClickLeftFrameBtn()
        }
        else if(e.key === "ArrowRight") {
            this.handleClickRightFrameBtn()
        }
    }

    handleClickPlayAndPauseBtn = () => {
        const isPause = !this.state.isPause
        this.setState({ isPause })
        this.playAll(isPause, false)
    }

    handleFrameChange = ({ to, from }) => {
        this.value = {
            min: from, 
            max: to
        }
        const curMusicTime = this.value.min / 1000
        if (this.sliderRef && this.sliderRef.state.handles) {
            //핸들 위치를 맞추기 위한 값 세팅
            this.sliderRef.state.handles[0].val = this.value.min + (this.props.cropDuration / 2 * 1000);
        }
        this.setState({ curMusicTime }, () => {
            this.playAll(this.state.isPause, true)
        })
    }

    handleClickStopBtn = () => {
        this.setState({ isPause: true })
        this.playAll(true, true)
    }

    handleClickLeftFrameBtn = () => {
        const { cropDuration } = this.props
        const timeData = {
            from: Math.max(0, (this.value.min - 100)),
            to: Math.max(cropDuration * 1000, (this.value.max - 100))
        }
        this.handleFrameChange(timeData);
    }

    handleClickRightFrameBtn = () => {
        const { duration } = this.state
        const { cropDuration } = this.props
        const timeData = {
            from: Math.min((duration - cropDuration) * 1000, (this.value.min + 100)),
            to: Math.min(duration * 1000, (this.value.max + 100))
        }
        this.handleFrameChange(timeData);
    }

    handleChangeUseAudio = (e) => {
        this.setState({ isCheckedUseAudio: e.target.checked })
    }

    renderCropper = () => {
        const { cropDuration } = this.props
        const { isCheckedUseAudio, duration, curVideoTime } = this.state

        return (
            <Fragment>

                <canvas id='c' width={600} height={375.5}></canvas>
                <video 
                    ref={ref => { this.videoRef = ref; }} 
                    src={this.state.src} 
                    id='v' 
                    style={{ display: 'none' }} 
                    width={this.state.vWidth} 
                    height={this.state.vHeight}
                    muted={!isCheckedUseAudio}
                    autoPlay={true}
                    onCanPlay={(e) => {
                        if (!duration) {
                            this.setState({ 
                                isReadyVideo: true,
                                duration: e.target.duration, 
                                vWidth: e.target.videoWidth, 
                                vHeight: e.target.videoHeight
                            }, () => { 
                                this.playAll()
                            });
                        }
                    }}
                    onPlaying={() => {
                        clearInterval(this.intervalId);
                        this.intervalId = setInterval(this.checkFrameInRange, 33);
                    }}
                    onError={() => {
                        this.props.closeDialog();
                        alert(i18n.t("makevideo.error.unsupported.video"))
                    }}
                />
                <br></br>
                <p className="dialog_subtitle">
                    {i18n.t("videocrop-subtitle1")}
                    <img src="https://front.videomonster.com/images-7cuytg20/web/ic_crop_area.png" alt="" />
                </p>
                <p className="videoCrop-container-text">{i18n.t("videocrop-text1")}</p>
                {/* <p className="videoCrop-container-text">{i18n.t('videocrop-error')}</p> */}

                <p className="dialog_subtitle" style={{ marginTop: '15px' }}>
                    {i18n.t("videocrop-subtitle2")}
                    <img src="https://front.videomonster.com/images-7cuytg20/web/ic_crop_duration.png" alt="" />
                </p>
                <p className="videoCrop-container-text">{i18n.t("videocrop-text2")}</p>
  
                <div className="video-slider-container">
                    <Slider
                        setSliderRef={ref => this.sliderRef = ref}
                        onChangeTime={this.changeTime}
                        length={cropDuration} // 크롭 길이
                        max={duration} // 비디오 총 길이
                        indicatorValue={curVideoTime}
                    />
                </div>
            </Fragment>
        );

    }
    render() {
        const { isPause, isCheckedUseAudio } = this.state
        const { open } = this.props
        const style = {
            marginRight: "10px",
            float: 'left'
        }

        return (
            <Dialog open={open} maxWidth={"lg"}>
                <div className="videoCrop-container">
                    <div 
                        ref={ref => ref && ref.focus()}
                        tabIndex="0"
                        onKeyDown={this.handleKeyPress}
                    >
                        <p className="dialog_title">{i18n.t("videocrop-title")}</p>

                        {this.renderCropper()}

                        <div className="dialog-controller-container">
                            <img onClick={this.handleClickLeftFrameBtn} src="https://front.videomonster.com/images-7cuytg20/web/frameMoveLeft.svg" alt={`icon-frame-move-left`}/>
                            <img onClick={this.handleClickPlayAndPauseBtn} src={isPause ? "https://front.videomonster.com/images-7cuytg20/web/musicPlayBtn.svg" : "https://front.videomonster.com/images-7cuytg20/web/musicPauseBtn.svg"} alt={`icon-music-play`}/>
                            <img onClick={this.handleClickStopBtn} src="https://front.videomonster.com/images-7cuytg20/web/musicStopBtn.svg" alt={`icon-music-stop`}/>
                            <img onClick={this.handleClickRightFrameBtn} src="https://front.videomonster.com/images-7cuytg20/web/frameMoveRight.svg" alt={`icon-frame-move-right`}/>
                        </div>

                        <div className="VMButton-container">
                            <div className="checkbox-container">
                                <input type="checkbox" id="audio-checkbox" checked={isCheckedUseAudio} onChange={this.handleChangeUseAudio}></input>
                                <label htmlFor="audio-checkbox">{i18n.t("videocrop-useaudio")}</label>
                            </div>
                            <VMButton onClick={this.props.closeDialog} width={'100px'} height={'30px'} style={{ float: 'left' }} >{i18n.t("ImageCropDialog.button.close")}</VMButton>
                            <VMButton color="primary-v2" onClick={this.endImageCrop} style={style} width={'100px'} height={'30px'}>{i18n.t("ImageCropDialog.button.complete")}</VMButton>
                        </div>
                    </div>
                </div>

            </Dialog>
        );
    }
}

export default VideoCrop;